export default function Facebook({ className, ...rest }: { className?: string }) {
  return (
    <svg
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="20"
      viewBox="0 0 11 20"
      fill="none"
      className={className}
    >
      <path
        d="M0.322581 10.652H2.5149V19.6774C2.5149 19.8556 2.65929 20 2.83748 20H6.55465C6.73284 20 6.87723 19.8556 6.87723 19.6774V10.6945H9.39748C9.56135 10.6945 9.69922 10.5715 9.71793 10.4088L10.1007 7.08606C10.1112 6.99465 10.0823 6.9031 10.0211 6.83452C9.95987 6.76587 9.87226 6.72658 9.78032 6.72658H6.87735V4.64374C6.87735 4.01587 7.21542 3.69748 7.88226 3.69748C7.97729 3.69748 9.78032 3.69748 9.78032 3.69748C9.95852 3.69748 10.1029 3.55303 10.1029 3.3749V0.324968C10.1029 0.146774 9.95852 0.0023871 9.78032 0.0023871H7.16452C7.14606 0.00148387 7.1051 0 7.04471 0C6.59084 0 5.01323 0.0890967 3.76703 1.23555C2.38626 2.506 2.57819 4.02716 2.62406 4.2909V6.72652H0.322581C0.144387 6.72652 0 6.8709 0 7.0491V10.3294C0 10.5075 0.144387 10.652 0.322581 10.652Z"
        fill="currentColor"
      />
    </svg>
  )
}
